<template>
  <div id="AddAndEditDept">
    <el-dialog :center="true" :id="titleType" :title="titleType==='add'?'部门新增':'部门修改'" :visible.sync="dialogVisible" width="500px" @close="resetForm('currentDept')">
      <el-form :model="currentDept" :rules="rules" ref="currentDept" label-width="100px" class="demo-ruleForm">
        <el-form-item label="部门名称" prop="departName">
          <el-input class="eb-input" v-model="currentDept.departName"></el-input>
        </el-form-item>
        <el-form-item label="上级部门">
          {{currentDept.parentDeptName}}
        </el-form-item>
        <el-form-item label="部门描述" prop="departDesc">
          <el-input class="eb-textarea" type="textarea" v-model="currentDept.departDesc"></el-input>
        </el-form-item>
      </el-form>
      <div class="eb-button-group">
        <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="resetForm('currentDept')">取消</el-button>
        <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="confirmBtn('currentDept')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
import { saveDepartment, updateDepartment } from '@/services/org/depart-service';
export default {
  name: 'AddAndEditDept',
  data() {
    return {
      dialogVisible: false,
      titleType: '',
      currentDept: {},
      rules: {
        departName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        departDesc: [
          { required: true, message: '请填写部门描述', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在1 到 100 个字符', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    eventBus.$on('addDept', (type, departId, parentDeptName) => {
      this.titleType = type;
      this.currentDept = {};
      this.currentDept.parentId = departId;
      this.currentDept.parentDeptName = parentDeptName;
      this.dialogVisible = true;
    });
    eventBus.$on('editDept', (type, dept) => {
      this.titleType = type;
      this.currentDept = dept;
      this.dialogVisible = true;
    });
  },
  methods: {
    confirmBtn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.titleType === 'add') {
            this.addDept();
          } else {
            this.editDept();
          }
        } else {
          return false;
        }
      });
    },
    async addDept() {
      var params = {
        parrentId: this.currentDept.parentId,
        departName: this.currentDept.departName,
        departDesc: this.currentDept.departDesc
      };
      try {
        let { data } = await saveDepartment(params);
        if (data.returnCode === '01') {
          this.dialogVisible = false;
          this.$message.success('新增部门成功！');
          eventBus.$emit('addOrEditDeptsuccess');
        } else {
          this.$message.error('新增部门失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    },
    async editDept() {
      var params = {
        departId: this.currentDept.departId,
        departName: this.currentDept.departName,
        departDesc: this.currentDept.departDesc
      };
      try {
        let { data } = await updateDepartment(params);
        if (data.returnCode === '01') {
          this.dialogVisible = false;
          this.$message.success('修改部门成功！');
          eventBus.$emit('addOrEditDeptsuccess');
        } else {
          this.$message.error('修改部门失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    },
    resetForm: function(formName) {
      this.dialogVisible = false;
      this.$refs[formName].resetFields();
    }
  },
  beforeDestroy() {
    eventBus.$off('addDept');
    eventBus.$off('editDept');
  }
};
</script>
<style lang="less" scoped>
</style>
